export const LoaderContent = {
    LOGIN: {
        title: "Logging in",
        content: "Just a moment. We are logging you in",
    },
    SIGNUP_CONFIRM: {
        loaderHeader: "Confirming Account",
        loaderText: "Just a moment. We are confirming your account",
    },
    SIGN_OUT: {
        loaderHeader: "Signing out",
        loaderText: "Just a moment. We are signing you out",
    },
    FORGOT_PASSWORD: {
        loaderHeader: "Forgot Password",
        loaderText: "Sending you an email with the verification code",
    },
    FORGOT_PASSWORD_SUBMIT: {
        loaderHeader: "Forgot Password Submit",
        loaderText: "Resetting your password",
    },
    FEEDBACK: {
        title: "Senting your feedback",
        content: "Please wait while we senting your feedback",
    },
    METAMASK_TRANSACTION: {
        title: "Waiting for Metamask Interaction",
        content: "Please confirm the transaction in the Metamask to proceed",
    },
    BLOCKHAIN_SUBMISSION: {
        title: "Waiting for Blockchain Submission",
        content: "Waiting for the transaction to get completed in the blockchain",
    },
    ORG_SETUP_CREATE: {
        title: "Creating Organization",
        content: "Just a moment. We are creating organization to draft",
    },
    ORG_SETUP_FINISH_LATER: {
        title: "Saving Draft",
        content: "Just a moment. We are saving your changes to draft",
    },
    ORG_SETUP_SUBMIT_FOR_APPROVAL: {
        title: "Submit for Approval",
        content: "Just a moment. We are submitting your changes for approval",
    },
    ORG_SETUP_PUBLISH_TO_IPFS: {
        title: "Publish to metadata storage",
        content: "Just a moment. We are publishing the metadata to metaddata storage",
    },
    ORG_SETUP_SAVING_TRANSACTION: {
        title: "Saving Transaction",
        content: "Just a moment. We are saving your transaction",
    },
    ACCEPT_INVITATION: {
        title: "Accepting Invitation",
        content:
            "Just a moment. We are adding you to the organization. Once done, you will be taken to the organization setup page",
    },
    VERIFY_INVITATION_CODE: {
        title: "Verifying Code",
        content: "Just a moment. We are verifying your invitation code",
    },
    GET_ALL_MEMBERS: {
        title: "Fetching Members",
        content: "Just a moment. We are fetching the details of all the members",
    },
    INVITE_MEMBERS: {
        title: "Inviting Members",
        content: "Just a moment. We are sending invitation to the members",
    },
    ADD_MEMBERS_TO_BLOCKCHAIN: {
        title: "Adding Members to Blockchain",
        content: "Just a moment. We are adding members to blockchain",
    },
    PUBLISH_MEMBERS: {
        title: "Publishing Members to blockchain",
        content: "Just a moment. We are publishing members to the blockchain",
    },
    GET_ALL_SERVICES: {
        title: "Retrieving the list of services",
        content: "Just a moment. We are retrieving the list of services",
    },
    INIT_SERVICE_CREATION: {
        title: "Initializing Service Creation",
        content: "Just a moment. We are initializing the service creation page",
    },
    CREATE_SERVICE: {
        title: "Creating Service",
        content: "Just a moment. We are creating a service",
    },
    SAVE_SERVICE_DETAILS: {
        title: "Saving service details",
        content: "Just a moment. We are saving the service details",
    },
    GET_SERVICE_DETAILS: {
        title: "Fetching service details",
        content: "Just a moment. We are fetching the service details",
    },
    FREE_CALL_SIGNER_ADDRESS: {
        title: "Retrieving Signer Address",
        content: "Just a moment. We are creating a service",
    },
    SUBMIT_SERVICE_FOR_REVIEW: {
        title: "Submitting for review",
        content: "Just a moment. We are submitting the service for review",
    },
    PUBLISH_SERVICE_TO_IPFS: {
        title: "Publish service to metadata provider",
        content: "Just a moment. We are publishing to to metadata provider",
    },
    PUBLISH_SERVICE_TO_BLOCKCHAIN: {
        title: "Publish service to blockchain",
        content: "Just a moment. We are publishing to blockchain",
    },
    SAVE_SERVICE_TRANSACTION: {
        title: "Saving service transaction",
        content: "Just a moment. We are saving the transaction hash",
    },
    UPLOAD_FILE: {
        title: "Uploading...",
        content: "Just a moment. We are uploading the file",
    },
    SAMPLE_DAEMON_CONFIG: {
        title: "Retrieving Sample Daemon config",
        content: "Just a moment. We are retrieving the sample daemon configuration",
    },
    CONNECT_METAMASK: {
        title: "Please connect Metamask",
        content: "Please connect your Metamask Wallet",
    },
    GET_CLAIMS_LIST: {
        title: "Waiting for MM interaction",
        content:
            "Please approve the two requests in your Metamask wallet to fetch the latest claims list",
    },
    START_CHANNEL_CLAIMS: {
        title: "Starting the Claims of the selected payment channels",
        content: "Just a moment. We are initializing the claims of the selected payment channels",
    },
    SIGN_CLAIMS_IN_MM: {
        title: "Waiting for MM interaction",
        content: "Please sign the request for claiming channels in Metamask wallet",
    },
    CLAIMING_CHANNELS_IN_BLOCKCHAIN: {
        title: "Claiming channels in blockchain",
        content: "Please don't reload or go back, the channel is being claimed in blockchain",
    },
    VALIDATING_DAEMON_ENDPOINTS: {
        title: "Validating daemon endpoints",
        content: "Please wait we are validating daemon",
    },
    GET_LATEST_ORG: {
        title: "Get latest org details",
        content: "Please wait until we fetch the latest organization details",
    },
    INITIATE_DAEMON: {
        title: "Initiating daemon",
        content: "Please wait until we initiate daemon",
    },
    INITIATE_DAEMON_AI: {
        title: "Initiating daemon + AI Service",
        content: "Please wait until we initiate daemon + AI Service",
    },
    CHECK_GIT_REPOSITORY: {
        title: "Checking github repository",
        content: "Please wait until we check github repository",
    },
};
